module.exports = __webpack_public_path__ + "img/icon_advantage_support@2x.934b2581.png";